export default __webpack_public_path__ + "static/media/follow_up_with_video.999a9375.gif";